import createSubscription from "./subscriptions";

const addListener = subscriptions => (event, listener) => {
	let eventSubscription = subscriptions.get(event);

	if (!eventSubscription) {
		eventSubscription = createSubscription();
		subscriptions.set(event, eventSubscription);
	}

	return eventSubscription.subscribe(listener);
};

const notifyListeners = subscriptions => (event, ...args) => {
	const eventSubscription = subscriptions.get(event);
	if (!eventSubscription) return;
	eventSubscription.notify(...args);
};

const emitterApi = subscriptions => ({
	on: addListener(subscriptions),
	notify: notifyListeners(subscriptions),
});

/**
 * Creates new lightweight event emitter
 *
 * @type {() => import("./types").IEmitter}
 */
const Emitter = () => emitterApi(new Map());

export default Emitter;
